import React from "react";
import { withTranslation } from "react-i18next";
import { differenceInMinutes, format } from "date-fns";
import {
  FaBatteryFull,
  FaBatteryHalf,
  FaBatteryEmpty,
  FaBolt,
  FaTachometerAlt,
  FaCrosshairs,
  FaWalking,
  FaCar,
  FaCircle,
} from "react-icons/fa";
import "./AttendanceInfoWindow.css";

function AttendanceInfoWindow({ worker, position, attendance, t }) {
  const getBatteryIcon = (level, isCharging) => {
    if (isCharging)
      return <FaBolt style={{ color: "#ffc107", marginLeft: "5px" }} />;
    if (level > 60) return <FaBatteryFull style={{ color: "#28a745" }} />;
    if (level > 30) return <FaBatteryHalf style={{ color: "#ffc107" }} />;
    return <FaBatteryEmpty style={{ color: "#dc3545" }} />;
  };

  const getActivityIcon = (activityType) => {
    switch (activityType) {
      case "walking":
        return <FaWalking />;
      case "driving":
        return <FaCar />;
      case "still":
        return <FaCircle />;
      default:
        return <FaCircle />;
    }
  };

  const isStale =
    position &&
    position.timestamp &&
    differenceInMinutes(new Date(), new Date(position.timestamp)) > 5;

  return (
    <div className="attendance-info-window">
      <h3 className="worker-name">
        {worker.first_name} {worker.last_name}
      </h3>
      {worker.employee_id && (
        <p className="worker-detail">
          <strong>{t("Matrícula")}:</strong> {worker.employee_id}
        </p>
      )}
      {worker.department && (
        <p className="worker-detail">
          <strong>{t("Departamento")}:</strong> {worker.department}
        </p>
      )}
      {worker.job_title && (
        <p className="worker-detail">
          <strong>{t("Cargo")}:</strong> {worker.job_title}
        </p>
      )}

      {attendance && (
        <div className="attendance-section">
          <h4>{t("Status de Ponto")}</h4>
          <p className="worker-detail">
            <strong>{t("Status")}:</strong>{" "}
            {attendance.is_clocked_in ? t("Presente") : t("Ausente")}
          </p>
          {attendance.last_timestamp && (
            <p className="worker-detail">
              <strong>
                {attendance.last_action === "clock_in"
                  ? t("Hora de Entrada")
                  : t("Hora de Saída")}
                :
              </strong>{" "}
              {format(new Date(attendance.last_timestamp), "HH:mm:ss")}
            </p>
          )}
          {attendance.current_work_duration && (
            <p className="worker-detail">
              <strong>{t("Duração do Expediente")}:</strong>{" "}
              {Math.floor(attendance.current_work_duration.hours)}h{" "}
              {Math.round(
                (attendance.current_work_duration.hours -
                  Math.floor(attendance.current_work_duration.hours)) *
                  60
              )}
              m
            </p>
          )}
        </div>
      )}

      {position && (
        <div className="position-section">
          <h4>{t("Informações de Localização")}</h4>
          {isStale && (
            <p className="stale-warning">
              <span role="img" aria-label="warning">
                ⚠️
              </span>{" "}
              {t("Dados Desatualizados")}
            </p>
          )}
          <p className="worker-detail">
            <strong>{t("Última Atualização")}:</strong>{" "}
            {format(new Date(position.timestamp), "dd/MM/yyyy HH:mm:ss")}
          </p>
          <p className="worker-detail">
            <strong>{t("Tipo de Atividade")}:</strong>{" "}
            {getActivityIcon(position.activity_type)}{" "}
            {t(
              position.activity_type === "walking"
                ? "Andando"
                : position.activity_type === "driving"
                ? "Dirigindo"
                : "Parado"
            )}
          </p>
          {position.speed !== null && position.speed !== undefined && (
            <p className="worker-detail">
              <FaTachometerAlt /> <strong>{t("Velocidade Atual")}:</strong>{" "}
              {position.speed.toFixed(1)} km/h
            </p>
          )}
          {position.accuracy && (
            <p className="worker-detail">
              <FaCrosshairs /> <strong>{t("Precisão GPS")}:</strong>{" "}
              {position.accuracy.toFixed(1)}m
            </p>
          )}
          {position.battery_level !== null &&
            position.battery_level !== undefined && (
              <p className="worker-detail">
                {getBatteryIcon(position.battery_level, position.is_charging)}{" "}
                <strong>{t("Nível de Bateria")}:</strong>{" "}
                {position.battery_level}%
              </p>
            )}
        </div>
      )}
    </div>
  );
}

export default withTranslation()(AttendanceInfoWindow);
